module.exports = __webpack_public_path__ + "static/img/10.53baf1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/10.png
// module id = HeOj
// module chunks = 0